
import React, { useState } from 'react';
import { usePersonaContext } from '@/contexts/PersonaContext';
import { Check, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const PersonaDropdown = ({ className }: { className?: string }) => {
  const { personas, currentPersona, switchPersona } = usePersonaContext();
  const [isOpen, setIsOpen] = useState(false);

  if (!currentPersona) return null;

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger 
        className={`flex items-center gap-2 text-sm font-medium px-3 py-2 rounded-md border ${
          className || "hover:bg-gray-100 border-gray-200"
        }`}
        data-testid="persona-dropdown"
      >
        {currentPersona.name}
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-white shadow-lg z-50">
        {personas.map((persona) => (
          <DropdownMenuItem
            key={persona.id}
            onClick={() => {
              switchPersona(persona);
              setIsOpen(false);
            }}
            className="flex items-center justify-between cursor-pointer hover:bg-gray-100 py-2"
          >
            {persona.name}
            {currentPersona.id === persona.id && (
              <Check className="h-4 w-4" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PersonaDropdown;
